import { createContext } from 'react';
export const GlobalContext = /*#__PURE__*/createContext(null);